export const LOADING = 'posts/LOADING';
export const GET_ALL_POSTS = 'posts/GET_ALL_POSTS';

export const CREATE_POST_SUCCESS = 'posts/CREATE_POST_SUCCESS';
export const COMPLETE_POST_SUCCESS = 'posts/COMPLETE_POST_SUCCESS';

export const SUBMIT_COMMENT_SUCCESS = 'posts/SUBMIT_COMMENT_SUCCESS';
export const DELETE_COMMENT_SUCCESS = 'posts/DELETE_COMMENT_SUCCESS';